import React, { Component } from "react";
import {
  View,
  Image,
  TouchableOpacity,
  Dimensions,
  BackHandler,
  Linking,
} from "react-native";
import { icons } from "../theme/icons";
import { homeStyles, appStyles, componentStyles } from "../theme/styles";
import TextView from "../components/TextView";
import {
  blueDarkColor,
  greenLightColor,
  greenDarkColor,
  redColor,
  redLightColor,
  yellowLightColor,
  yellowDarkColor,
  blueLightColor,
} from "../theme/colors";
import {
  notifictionNumberRequest,
  getStatusRequest,
  changeStatusRequest,
  updateLocationRequest,
  orderListRequest,
  getNumberRequest,
  myProfileRequest,
  versionAppRequest,
  walletInfoRequest,
  loginRequest,
  logoutRequest,
} from "../utils/api";
import LinearGradient from "react-native-linear-gradient";
import Waiting from "../components/Waiting";
import * as Location from "expo-location";
import {
  persianNumber,
  showMessage,
  getError,
  showPromptDownload,
} from "../utils/utils";
import { clearUsers } from "../database/UserDal";
import { wp } from "../utils/responsive";
import { inject, observer } from "mobx-react";

@inject("store")
@observer
export default class HomeScreen extends Component {
  _timerId = 0;

  constructor(props) {
    super(props);
    this.state = {
      notifiction: 0,
      slider_waiting: true,
      waiting: true,
      sliders: [],
      status: "busy",
      number_done: 0,
      number_doing: 0,
      number_cancel: 0,
      number_order: 0,
      number_order_fav: 0,
    };
  }

  render() {
    return (
      <View style={homeStyles.container}>
        <View style={appStyles.toolbarWraper}>
          <TouchableOpacity
            style={appStyles.row}
            onPress={() => {
              this.setState({
                notifiction: 0,
              });
              this.props.navigation.navigate("notifiction");
            }}
          >
            <Image
              source={icons["notifiction"]}
              style={appStyles.toolbarIcon}
            />
            {this.state.notifiction > 0 ? (
              <View style={homeStyles.notifictionWraper}>
                <TextView style={homeStyles.notifictionCount}>
                  {this.state.notifiction}
                </TextView>
              </View>
            ) : null}
          </TouchableOpacity>
          <TextView style={appStyles.toolbarTitle}>آد همکار</TextView>
          <TouchableOpacity
            onPress={() => {
              this.props.navigation.openDrawer();
            }}
          >
            <Image source={icons["menu"]} style={appStyles.toolbarIcon} />
          </TouchableOpacity>
        </View>

        <View style={[appStyles.centerAll, { flex: 1, marginBottom: 200 }]}>
          <View style={{ width: 100, height: 100 }}>
            <View style={homeStyles.profileWraper}>
              <Image
                source={{ uri: this.state.image }}
                style={homeStyles.profile}
              />
            </View>
            {this.state.status === "free" ? (
              <View
                style={{
                  backgroundColor: "#31CF75",
                  position: "absolute",
                  right: 0,
                  top: 5,
                  width: 26,
                  height: 26,
                  borderRadius: 13,
                  borderWidth: 3,
                  borderColor: "white",
                }}
              />
            ) : null}
          </View>
          <TextView
            style={{
              textAlign: "center",
              margin: 30,
            }}
          >
            {this.state.status === "busy"
              ? "در حال حاضر آفلاین هستید"
              : "در حال حاضر آنلاین هستید"}
          </TextView>
          <TouchableOpacity
            activeOpacity={0.5}
            onPress={() => {
              this.setState({
                waiting: true,
              });
              if (this.state.status === "busy") {
                this.getCurrentPosition();
              } else {
                changeStatusRequest("busy", (isConnect, response) => {
                  this.setState({
                    waiting: false,
                  });
                  if (isConnect && response.isSuccess) {
                    this.setState({
                      status: "busy",
                    });
                    this._stopAutoPlay();
                  } else {
                    showMessage("", getError(response));
                  }
                });
              }
            }}
          >
            <LinearGradient
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={
                this.state.status !== "busy"
                  ? [greenLightColor, greenDarkColor]
                  : ["#BCBCBC", "#CBCBCB"]
              }
              style={[
                componentStyles.gradinatButton,
                appStyles.shadow,
                appStyles.center,
                {
                  width: 250,
                  height: 40,
                },
              ]}
            >
              <TextView
                isbold={true}
                numberOfLines={1}
                style={[
                  {
                    flexGrow: 2,
                    color: "white",
                    textAlign: "center",
                    fontSize: 18,
                  },
                ]}
              >
                {this.state.status === "busy"
                  ? "الان , آماده خدمت هستم"
                  : "الان , قادر به ارائه خدمت نیستم"}
              </TextView>
            </LinearGradient>
          </TouchableOpacity>
        </View>

        {this.state.number_order > 0 || this.state.number_order_fav > 0 ? (
          <View
            style={[
              appStyles.bottomView,
              appStyles.center,
              appStyles.shadow,
              { minHeight: 100 },
            ]}
          >
            {this.state.number_order > 0 ? (
              <TouchableOpacity
                activeOpacity={0.5}
                onPress={() => {
                  this.props.navigation.navigate("requests", {
                    onRefresh: () => {
                      this.getCurrentPosition();
                    },
                  });
                }}
              >
                <LinearGradient
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 0 }}
                  colors={[blueLightColor, blueDarkColor]}
                  style={[
                    componentStyles.gradinatButton,
                    {
                      width: wp(90),
                      borderRadius: 25,
                      height: 50,
                    },
                  ]}
                >
                  <View style={componentStyles.countWraper}>
                    <TextView
                      isbold={true}
                      style={{
                        color: greenDarkColor,
                        fontSize: 18,
                      }}
                    >
                      {persianNumber(this.state.number_order)}
                    </TextView>
                  </View>
                  <TextView isbold={true} style={componentStyles.requestText}>
                    مشاهده درخواست ها
                  </TextView>
                </LinearGradient>
              </TouchableOpacity>
            ) : null}
            {this.state.number_order_fav > 0 ? (
              <TouchableOpacity
                activeOpacity={0.5}
                onPress={() => {
                  this.props.navigation.navigate("requests", {
                    onRefresh: () => {
                      this.getCurrentPosition();
                    },
                  });
                }}
              >
                <LinearGradient
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 0 }}
                  colors={[greenLightColor, greenDarkColor]}
                  style={[
                    componentStyles.gradinatButton,
                    {
                      width: Dimensions.get("window").width - 100,
                      borderRadius: 25,
                      height: 50,
                    },
                  ]}
                >
                  <View style={componentStyles.countWraper}>
                    <TextView
                      isbold={true}
                      style={{
                        color: greenDarkColor,
                        fontSize: 18,
                      }}
                    >
                      {persianNumber(this.state.number_order_fav)}
                    </TextView>
                  </View>
                  <TextView isbold={true} style={componentStyles.requestText}>
                    سفارش منتخب دارید
                  </TextView>
                </LinearGradient>
              </TouchableOpacity>
            ) : null}
          </View>
        ) : null}
        {this.state.number_order === 0 && this.state.number_order_fav === 0 ? (
          <View style={[homeStyles.bottomWraper, appStyles.shadow]}>
            <TextView style={{ color: "grey", marginTop: 30 }}>
              وضعیت خدمت شما
            </TextView>
          </View>
        ) : null}
        {this.state.number_order === 0 && this.state.number_order_fav === 0 ? (
          <View
            style={[
              appStyles.centerAll,
              appStyles.row,
              { position: "absolute", bottom: 80 },
            ]}
          >
            <LinearGradient
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={[redLightColor, redColor]}
              style={[
                appStyles.shadow,
                appStyles.center,
                {
                  width: 90,
                  height: 90,
                  borderRadius: 15,
                  margin: 10,
                },
              ]}
            >
              <TextView
                numberOfLines={1}
                style={[
                  {
                    color: "white",
                    textAlign: "center",
                    fontSize: 22,
                  },
                ]}
              >
                {persianNumber(this.state.number_cancel)}
              </TextView>
              <TextView
                numberOfLines={1}
                style={[
                  {
                    color: "white",
                    textAlign: "center",
                    margin: 10,
                    fontSize: 12,
                  },
                ]}
              >
                لغو شده
              </TextView>
            </LinearGradient>
            <LinearGradient
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={[yellowLightColor, yellowDarkColor]}
              style={[
                appStyles.shadow,
                appStyles.center,
                {
                  width: 90,
                  height: 90,
                  borderRadius: 15,
                  margin: 10,
                },
              ]}
            >
              <TextView
                numberOfLines={1}
                style={[
                  {
                    color: "white",
                    textAlign: "center",
                    fontSize: 22,
                  },
                ]}
              >
                {persianNumber(this.state.number_doing)}
              </TextView>
              <TextView
                numberOfLines={1}
                style={[
                  {
                    color: "white",
                    textAlign: "center",
                    margin: 10,
                    fontSize: 12,
                  },
                ]}
              >
                در حال انجام
              </TextView>
            </LinearGradient>
            <LinearGradient
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={[blueLightColor, blueDarkColor]}
              style={[
                appStyles.shadow,
                appStyles.center,
                {
                  width: 90,
                  height: 90,
                  borderRadius: 15,
                  margin: 10,
                },
              ]}
            >
              <TextView
                numberOfLines={1}
                style={[
                  {
                    color: "white",
                    textAlign: "center",
                    fontSize: 22,
                  },
                ]}
              >
                {persianNumber(this.state.number_done)}
              </TextView>
              <TextView
                numberOfLines={1}
                style={[
                  {
                    color: "white",
                    textAlign: "center",
                    margin: 10,
                    fontSize: 12,
                  },
                ]}
              >
                اتمام یافته
              </TextView>
            </LinearGradient>
          </View>
        ) : null}
        <Waiting waiting={this.state.waiting} />
      </View>
    );
  }

  componentWillMount() {
    this.props.navigation.addListener("focus", (payload) => {
      clearInterval(this._timerId);
      this._timerId = setInterval(() => {
        this.getCurrentPosition();
      }, 10000);
      getNumberRequest((isConnect, response) => {
        if (isConnect && response.isSuccess) {
          this.setState({
            number_done: response.data.number_done,
            number_doing: response.data.number_doing,
            number_cancel: response.data.number_cancel,
          });
        }
      });
      getStatusRequest((isConnect, response) => {
        if (isConnect && response.isSuccess) {
          this.setState(
            {
              status: response.data.status_job,
            },
            () => {
              if (this.state.status === "free") {
                this.getCurrentPosition();
              } else {
                this._stopAutoPlay();
                this.setState({
                  waiting: true,
                });
                orderListRequest((isConnect, response) => {
                  this.setState({
                    waiting: false,
                  });
                  if (isConnect && response.isSuccess) {
                    this.setState({
                      number_order: response.data.number_orders,
                      number_order_fav: response.data.number_orders_fav,
                    });
                  }
                });
              }
            }
          );
        } else {
          this.setState({
            waiting: false,
          });
        }
      });
    });
    this.props.navigation.addListener("blur", (payload) => {
      this._stopAutoPlay();
    });
    this.props.navigation.addListener("didBlur", (payload) => {
      this._stopAutoPlay();
    });
    notifictionNumberRequest((isConnect, response) => {
      if (isConnect && response.isSuccess) {
        this.setState({
          notifiction: response.data.number,
        });
      }
    });

    myProfileRequest((isConnect, response) => {
      if (isConnect && response.isSuccess) {
        this.setState({
          image: response.data.picpath,
        });
      }
    });

    walletInfoRequest((isConnect, response) => {
      if (isConnect && response.isSuccess) {
        this.props.store.changeWalletAmount(response.data.sharge);
      }
    });

    versionAppRequest((isConnect, response) => {
      if (isConnect && response.data.isSuccess) {
        if (parseFloat(response.data.data.version) > 4) {
          showPromptDownload(
            "ورژن جدید",
            response.data.data.comment,
            () => {
              Linking.openURL(response.data.data.linkapp);
            },
            () => {
              if (response.data.data.needupdate === "yes") {
                BackHandler.exitApp();
              }
            },
            response.data.data.needupdate
          );
        }
      } else {
        if (response?.message?.includes("403")) {
          logoutRequest((isConnect, response) => {
            clearUsers();
            Linking.openURL("https://servant.asandarman.ir/");
          });
        }
      }
    });
  }

  getCurrentPosition() {
    (async () => {
      let { status } = await Location.requestPermissionsAsync();
      if (status === "granted") {
        this.setState({
          waiting: false,
        });
        // showMessage('', 'عدم دریافت موقعیت لطفا مجددا سعی نمایید');
        // return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (this.state.status !== "free") {
            changeStatusRequest("free", (isConnect, response) => {
              if (isConnect && response.isSuccess) {
                this.setState({
                  status: "free",
                });
              } else {
                showMessage("", getError(response));
                this._stopAutoPlay();
                return;
              }
            });
          }
          getNumberRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
              this.setState({
                number_done: response.data.number_done,
                number_doing: response.data.number_doing,
                number_cancel: response.data.number_cancel,
              });
            }
          });

          updateLocationRequest(
            position.coords.latitude,
            position.coords.longitude,
            (isconnect, response) => {
              console.log(JSON.stringify(response));
            }
          );

          orderListRequest((isConnect, response) => {
            this.setState({
              waiting: false,
            });
            if (isConnect && response.isSuccess) {
              this.setState({
                number_order: response.data.number_orders,
                number_order_fav: response.data.number_orders_fav,
              });
            }
          });
        },
        (error) => {
          showMessage("", "عدم دریافت موقعیت لطفا مجددا سعی نمایید");
        }
      );
    })();
  }

  componentDidMount() {
    this._timerId = setInterval(() => {
      this.getCurrentPosition();
    }, 10000);
  }

  _stopAutoPlay() {
    if (this._timerId) {
      clearInterval(this._timerId);
      this._timerId = null;
    }
  }

  componentWillUnmount() {
    this._stopAutoPlay();
  }
}
